// extracted by mini-css-extract-plugin
module.exports = {"subscriptionDetailsButton":"subscriptionDetails_subscriptionDetailsButton__2ii2R","priceText":"subscriptionDetails_priceText__fvbTe"};